export const COMMIT_HASH = import.meta.env.COMMIT_HASH;

export const COMMIT_DATE = import.meta.env.COMMIT_DATE;

export const PROD = import.meta.env.PROD;

export const MODE = import.meta.env.MODE;
